

























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import AsesmenKeperawatanGadarPage from "@/components/AsesmenAwalGadar/AsesmenKeperawatanGadarPage.vue";
import AsesmenMedisGadarPage from "@/components/AsesmenAwalGadar/AsesmenMedisGadarPage.vue";
import SurveyPrimerGadarPage from "@/components/AsesmenAwalGadar/SurveyPrimerGadarPage.vue";
import CardStatusPernikahanGadar from "@/components/AsesmenAwalGadar/CardStatusPernikahanGadar.vue";
import AsuhanKeperawatanGawatDaruratCard from "@/pages/PemeriksaanIgdPage/AsuhanKeperawatanGawatDaruratCard.vue";
import AsuhanKebidananGawatDaruratCard from "@/pages/PemeriksaanIgdPage/AsuhanKebidananGawatDaruratCard.vue";
import { isEmpty } from "lodash";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";
import AsuhanKeperawatanGadarStore from "@/store/modules/AsuhanKeperawatanGadarStore";
import AsuhanKebidananGadarStore from "@/store/modules/AsuhanKebidananGadarStore";

@Component({
  components: {
    AsesmenKeperawatanGadarPage,
    SurveyPrimerGadarPage,
    AsesmenMedisGadarPage,
    CardStatusPernikahanGadar,
    AsuhanKeperawatanGawatDaruratCard,
    AsuhanKebidananGawatDaruratCard
  }
})
export default class Integrated extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) deepLink!: any;

  defaultTab = "tab-perawat";
  deepLinkedSubTab = false;

  paramDokter = {
    unit_id: this.stateuser.unit_id,
    reg: this.register,
    profesi: "Dokter"
  };

  param = {
    unit_id: this.stateuser.unit_id,
    reg: this.register
  };

  get stateuser() {
    return userModule.user;
  }

  get asesmenPerawatDone() {
    return !isEmpty(AsesmenGadarKeperawatanStore.asesmen?.content.perawat)
      ? true
      : false;
  }

  get asesmenSurveyDone() {
    return !isEmpty(AsesmenSurveyPrimerGadarStore.asesmen) ? true : false;
  }

  get asesmenMedisDone() {
    return !isEmpty(AsesmenGadarMedisStore.asesmen?.content.dokterPenerima)
      ? true
      : false;
  }

  mounted() {
    AsesmenGadarMedisStore.getByRegister(this.register);
    AsesmenGadarKeperawatanStore.getByRegister(this.register);
    AsesmenSurveyPrimerGadarStore.getByRegister(this.register);

    // master untuk kartu askep/askeb IGD di bawah asesmen keperawatan
    AsuhanKeperawatanGadarStore.getAllRefList();
    AsuhanKebidananGadarStore.getAllRefList();

    if (this.stateuser.profesi == "Dokter" && !this.deepLinkedSubTab) {
      this.defaultTab = "tab-dokter";
    }
  }

  @Watch("deepLink", { immediate: true })
  onDeepLink(payload) {
    if (!payload || payload.topTab !== "tab-assesmen") return;
    if (payload.elemId !== "tab-asesmen-awal-gadar" || !payload.subTab) return;
    this.defaultTab = payload.subTab;
    this.deepLinkedSubTab = true;
  }

  klikTabPerawat() {
    // const paramPerawat = {
    //   unit_id: this.stateuser.unit_id,
    //   reg: this.register,
    //   profesi: "Perawat",
    // };
    // storeDiagnosisPemeriksaan.actDiagnosis_perawat(paramPerawat);
    // storeRencanaPemeriksaan.actRencanaPemeriksaan_perawat(paramPerawat);
  }

  klikTabDokter() {
    // storeDiagnosisPemeriksaan.actDiagnosis_dokter(this.paramDokter);
    // storeRencanaPemeriksaan.actRencanaPemeriksaan_perawat(this.paramDokter);
  }

  soap() {
    this.$emit("isiSoap");
  }
}
